import React from 'react';
import { Grid, Typography, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { scopeLabel, storeName } from './reviewFormat';

export default function CycleHeader({ report }) {
    const { t } = useTranslation();

    if (!report) {
        return (
            <Grid container direction='column' alignItems='center' sx={{ padding: '2rem 1rem' }}>
                <Typography variant='h6'>{t('inventoryCheck.review.noCountInProgress')}</Typography>
                <Typography color='text.secondary'>{t('inventoryCheck.review.noCountExplain')}</Typography>
            </Grid>
        );
    }

    const opened = report.openedAt ? new Date(report.openedAt).toLocaleDateString() : '';

    return (
        <Grid container direction='column' sx={{ gap: '.5rem' }}>
            <Typography variant='h6'>{scopeLabel(t, report.scope)}</Typography>
            <Typography color='text.secondary'>
                {t('inventoryCheck.review.openedLabel')}: {opened}
            </Typography>
            <Typography>
                {t('inventoryCheck.review.countedLabel')}: {Number(report.counted ?? 0).toLocaleString('en-US')}
            </Typography>
            <Grid container sx={{ gap: '.5rem' }}>
                {(report.stores ?? []).map(store => (
                    <Chip
                        key={store.location}
                        color={store.finishedAt ? 'success' : 'warning'}
                        label={store.finishedAt
                            ? `${storeName(store.location)} — ${Number(store.scanned ?? 0).toLocaleString('en-US')} — ${t('inventoryCheck.review.finishedBy', { who: store.finishedBy })}`
                            : `${storeName(store.location)} — ${Number(store.scanned ?? 0).toLocaleString('en-US')}`}
                    />
                ))}
                {!report.bothStoresFinished && (
                    <Chip color='warning' variant='outlined' label={t('inventoryCheck.review.stillCounting')} />
                )}
            </Grid>
        </Grid>
    );
}
